import type { IconSvgObject } from './types';

const Download02Icon: IconSvgObject = [
  ["path", { d: "M8 12L12 16L16 12M12 15L12 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 8C19.2091 8 21 9.79086 21 12V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V12C3 9.79086 4.79086 8 7 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Download02Icon;
